var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.17C10.8126 0.983749 10.5592 0.879208 10.295 0.879208C10.0308 0.879208 9.77736 0.983749 9.59 1.17L6 4.71L2.46 1.17C2.27264 0.983749 2.01919 0.879208 1.755 0.879208C1.49081 0.879208 1.23736 0.983749 1.05 1.17C0.956272 1.26296 0.881877 1.37356 0.831109 1.49542C0.78034 1.61728 0.754202 1.74799 0.754202 1.88C0.754202 2.01201 0.78034 2.14272 0.831109 2.26458C0.881877 2.38644 0.956272 2.49704 1.05 2.59L5.29 6.83C5.38296 6.92373 5.49356 6.99812 5.61542 7.04889C5.73728 7.09966 5.86799 7.1258 6 7.1258C6.13201 7.1258 6.26272 7.09966 6.38458 7.04889C6.50644 6.99812 6.61704 6.92373 6.71 6.83L11 2.59C11.0937 2.49704 11.1681 2.38644 11.2189 2.26458C11.2697 2.14272 11.2958 2.01201 11.2958 1.88C11.2958 1.74799 11.2697 1.61728 11.2189 1.49542C11.1681 1.37356 11.0937 1.26296 11 1.17Z",
    fill: "#565758"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.4163d0d9ebb062b33c12392a5b0f8c84.svg";
export { ForwardRef as ReactComponent };